import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AddGalleryComponent } from '../shared/forms/add-gallery/add-gallery.component';
import { ArticlesService } from '../services/articles.service';
import { ModalService } from '../shared/modal/modal.service';
import { EditingService } from '../services/editing.service';
import { PageTitleComponent } from '../shared/page-title/page-title.component';
import { GalleryArticleComponent } from '../shared/gallery-article/gallery-article.component';

@Component({
  selector: 'app-for-sale',
  templateUrl: './for-sale.component.html',
  styleUrls: ['./for-sale.component.scss'],
  imports: [PageTitleComponent, GalleryArticleComponent]
})
export class ForSaleComponent {
  private articleService = inject(ArticlesService);
  private modal = inject(ModalService);
  private editService = inject(EditingService);
  private destroyRef = inject(DestroyRef);

  readonly editMode = this.editService.editMode;
  readonly type = 'for-sale';
  articles: any[] = [];

  constructor() {
    this.getArticles();
  }

  onAddAdvert() {
    this.modal.open(AddGalleryComponent, {data: {type: this.type, title: 'Create Advert on page ' + this.type, content: {}}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
        this.articleService.saveArticles(response);
        this.getArticles();
      });
  }

  onDeleted(id: string) {
    this.articles = this.articles.filter(article => article.id !== id);
  }

  getArticles() {
    this.articleService.getArticles(this.type).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      this.articles = data.sort((a, b) => (a.attributes.order || 0) - (b.attributes.order || 0));
    });
  }
}
